import FieldReadOnly from "../../read-only-value/read-only"
import FieldConfig from "../../../proto/field-config"
import {FieldFilterType} from "../../../proto/types"
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups"
import Format from "../../../../gd/utils/format"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import FieldMoment_ConditionForm from "./render/condition"
import {FIELD_CONDITIONS_DATE_WITH_NULL, FieldDate_filterFunc} from "../../../conditions/date"

/*

CAREFULL - I use it only in time report and expense to display moment created... it is supposed to be READ ONLY
us DATETIME field (or creat) when need date + time editable (!)

 */

export default class FieldMoment extends FieldReadOnly {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Moment";
        this.filterType         = FieldFilterType.DATE;
        this.typeGroup          = GROUP_DATE_TIME;
        this.typeDescription    = "Moment read only";
        this.icon               = 'i5-calendar';

        this.conditionTypes     = FIELD_CONDITIONS_DATE_WITH_NULL

        this.renderComponents.conditionForm = FieldMoment_ConditionForm
        this.renderComponents.filterForm    = FieldMoment_ConditionForm

        // this.renderComponents.glistView = this.renderComponents.viewSmall

        // this.renderComponents.viewSmall     =

        this.filterFunc                     = FieldDate_filterFunc
    }

    getDisplayValue(value: Moment): string {
        // @ts-ignore
        if (!value) return value
        return Format.datetimeUserFormat(value)
    }

    sortValue(value:any) {
        return value ? DatetimeUtils.datetimeToMoment(value).format('x') : 0;
    }

    normalizeToCSVValue(model:any): any {
        const rawValue = super.normalizeToCSVValue(model)
        const res: string | null = !_.isEmpty(rawValue) ? DatetimeUtils.momentToUTCISODatetime(moment(rawValue)) : null
        return !!res ? res : ''
    }
}
